import {
    PcsListElementSubjectListElementType,
    PcsListElementType,
    PcsListMapType,
    PcsSearchParamType
} from "../interface";
import moment from "moment";

export const pcsSearchParamInit: PcsSearchParamType = {
    fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    limit: 10,
    pageNo: 1,
    purchaseOrderState: "0",
    toDate: moment().add(1, 'months').format("YYYY-MM-DD"),
    orderFlag: "N",
    userId: null
}

export const pcsListMapInit: PcsListMapType = {
    list: [],
    totalCount: 0
}

export const pcsListElementInit: PcsListElementType = {
    purchaseOrderId: 0,
    purchaseOrderNo: "",
    newDtRequestShipment: "",
    purchaseOrderDt: "",
    newDtShipment: "",
    currencyName: "",
    newTxtCollection: "",
    purchaseOrderState: 1,
    newPShipment: 0,
    newPPayment: 0,
    createdon: "",
    modifiedon: "",
    newLRecipientValue: "",
    newLAddressValue: "",
    newLInvoiceAgentValue: "",
    purchaseOrderer: 0,
    customerMemo: "",
    newPShipmentName: "",
    ordererName: "",
    paymentName: "",
    recipientName: "",
    recipientMobile: "",
    purchaseOrderStateName: "",
    subjectList: [],
    taxCharge: "",
    taxEmail: "",
    taxMobile: "",
    addressName: "",
    address1: "",
    address2: "",
    newDAmount: "",
    owningUserName: "",
}

export const pcsListElementSubjectListElementInit: PcsListElementSubjectListElementType = {
    purchaseOrderSubjectId: 0,
    purchaseOrderId: 0,
    newLErpProductValue: "",
    newTxtStandard: "",
    createdon: "",
    newIQty: 0,
    productName: "",
    productGroupName: "",
    productRange: "",
    newLProductGroupValue: "",
    newProductGroupid: "",
}